const customMapsMappings = {
  "california": "https://gist.githubusercontent.com/dhth/54972f96b273828910db1a065b240292/raw/b9be733dee52b8eaee696b90f27e2f71ac302afc/mappings-CA-counties.topo.json",
  "texas": "https://gist.githubusercontent.com/dhth/e948feebfa1e7feead943a46d257ac01/raw/c8a1019c1cb800400eb95fd6bfcfaf7c02cb682a/TX.topo.json"
}
const projectionMappings = {
  "california": [-120, 37],
  "texas": [-99.43, 31.47]
}

const scaleMultiplierMappings = {
  "california": 5.5,
  "texas": 5.5,
  "europe": 1
}

const maps = {
  US: [
    {
      type: "time-series-chloropleth",
      url: "/us-population",
      urlTitle: "Population Trends (1790 - 1990)",
      mapsDataKey: "USPopulation",
      description: "",
      title: "Population of US States (1790 - 1990)",
      scope: "usa",
      dataStats: {
        min: 1062,
        max: 29760021,
        colorMin: "#CFEC9D",
        colorMax: "#324F00",
        toolTipText: "Population: "
      },
      citationSource: "https://www.census.gov/population/www/censusdata/pop1790-1990.html",
      dataSource:
        "https://gist.githubusercontent.com/dhth/ed2e3b4dc32258232f19f80ee75bc92b/raw/baf3cd1a410ca47e242c2cf2c756c2d4fb9e3090/us-pop.json",
      tags: ["census", "population", "time-series"]
    },
    {
      type: "time-series-chloropleth",
      url: "/us-median-incomes",
      urlTitle: "Median Incomes Trends (1984 - 2018)",
      mapsDataKey: "USMedianIncomes",
      description: "",
      title: "Median Income of US States (1984 - 2018)",
      scope: "usa",
      dataStats: {
        min: 15430,
        max: 86345,
        colorMin: "#CCF2CC",
        colorMax: "#006599",
        toolTipText: "Median Income: &dollar;"
      },
      citationSource: "https://www.census.gov/data/tables/time-series/demo/income-poverty/time-series-income-households.html",
      dataSource:
        "https://gist.githubusercontent.com/dhth/65ccb3d017098debf12ce2dea7b7df23/raw/04d9ce7ae23ccc706e0b2e000e678d7b5d9ef73f/us-median-incomes.json",
      tags: ["census", "income", "time-series"]
    },
    {
      type: "time-series-chloropleth",
      url: "/us-grad-undergrad-enrollment",
      urlTitle: "Undergraduate and Graduate Enrollment",
      mapsDataKey: "USGradUnderGradEnrollment",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/02dad25b164fb7a16a9a70d73184e93e/raw/dbee55596be5500c8e625cf3fb3e1ff8717b4770/us-undergrad-grad-enrollment.json",
      title: "Undergraduate and Graduate Enrollment",
      scope: "usa",
      dataStats: {
        min: 50603,
        max: 3996227,
        colorMin: "#CCF2CC",
        colorMax: "#006599",
        toolTipText: ""
      },
      citationSource:"",
      tags: ["education"]
    }, 
    {
      type:"radio-based-chloropleth",
      url: "/us-mean-sat-scores-2018",
      urlTitle: "SAT Mean Scores of High School Seniors: 2018",
      // mapsDataKey: "USGradUnderGradEnrollment",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/b994c61f8740a998fe86836163b2342e/raw/31f4614c70147bf6ed24ec7ad3343fc370a8244d/sat_mean_scores_2018.json",
      title: "SAT Mean Scores of High School Seniors: 2018",
      scope: "usa",
      dataStats: {
        total_sat_mean_score: { min: 977, max: 1298, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total Sat Mean Score: "},
        erw_mean_score: { min: 497, max: 643, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "ERW Mean Score: " },
        math_mean_score: { min: 480, max: 655, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Math Mean Score: " },
        percent_taking_sat: { min: 2, max: 100, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Percent Taking Test: " }
      },
      citationSource: "https://nces.ed.gov/programs/digest/d18/tables/dt18_226.40.asp?current=yes",
      tags: ["education", "exam-scores"]
    },
    {
      type: "radio-based-chloropleth",
      url: "/us-high-school-completion-2017",
      urlTitle: "Rates of High School Completion",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/02594111e162d08c3f73b1206d4b3674/raw/ec846ac249446ff506cdb53df2322bb7b7b8a809/high-school-completion-2017.json",
      title: "Rates of high school completion among persons age 25 and over: 2017",
      scope: "usa",
      dataStats: {
        total: { min: 83.4, max: 93.2, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total: ", toolTipTextAfter: "&percnt;" },
        white: { min: 86.7, max: 99.2, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "White: ", toolTipTextAfter: "&percnt;" },
        black: { min: 79.2, max: 97.3, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Black: ", toolTipTextAfter: "&percnt;" },
        hispanic: { min: 57.0, max: 91.2, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Hispanic: ", toolTipTextAfter: "&percnt;" },
        asian: { min: 62.9, max: 95.5, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Asian: ", toolTipTextAfter: "&percnt;" },
        two_or_more_races: { min: 86.2, max: 96.7, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Two Or More Races: ", toolTipTextAfter: "&percnt;" }
      },
      textAboveMapControls: "Select a race/ethnicity:",
      citationSource: "https://nces.ed.gov/programs/digest/d18/tables/dt18_104.85.asp?current=yes",
      tags: ["education", "high-school"]
    },
    {
      type: "radio-based-chloropleth",
      url: "/us-bachelor-degree-attainment-2017",
      urlTitle: "Rates of Bachelor Degree Attainment",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/11674d429f86f219eed6f12219f6ae02/raw/89ca8dbf2b1c4e5f89616482b75870a18709ed13/7-bachelor-degree-attainment-2017.json",
      title: "Rates of bachelor's degree attainment among persons age 25 and over: 2017",
      scope: "usa",
      dataStats: {
        total: { min: 20.2, max: 57.2, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total: ", toolTipTextAfter: "&percnt;" },
        white: { min: 20.0, max: 90.5, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "White: ", toolTipTextAfter: "&percnt;" },
        black: { min: 12.8, max: 40.1, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Black: ", toolTipTextAfter: "&percnt;" },
        hispanic: { min: 6.3, max: 44.5, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Hispanic: ", toolTipTextAfter: "&percnt;" },
        asian: { min: 24.1, max: 82.1, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Asian: ", toolTipTextAfter: "&percnt;" },
        two_or_more_races: { min: 19.5, max: 83.3, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Two Or More Races: ", toolTipTextAfter: "&percnt;" }
      },
      textAboveMapControls: "Select a race/ethnicity:",
      citationSource: "https://nces.ed.gov/programs/digest/d18/tables/dt18_104.85.asp?current=yes",
      tags: ["education", "college"]
    },
    {
      type: "radio-based-chloropleth-with-time-series-data",
      url: "/us-average-salaries-of-school-teachers",
      urlTitle: "Average Base Salary of School Teachers",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/5f33866764451ac04ed791b1481c7cf3/raw/9e0a3490f11d9164adb8480daecc77e662df7fd6/8-average-salaries-of-school-teachers.json",
      title: "Average Base Salary for Full-Time Public Elementary and Secondary School Teachers",
      scope: "usa",
      dataStats: {
        bachelors: { min: 22000, max: 73180, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Average Salary: &dollar;"},
        masters: { min: 22000, max: 73180, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Average Salary: &dollar;" }
      },
      textAboveMapControls: "Choose highest degree attained:",
      citationSources: ["https://nces.ed.gov/programs/digest/d18/tables/dt18_211.30.asp?current=yes", "https://nces.ed.gov/programs/digest/d18/tables/dt18_211.40.asp?current=yes"],
      tags: ["education", "salaries"]
    },
    {
      type: "time-series-chloropleth",
      url: "/us-public-school-graduates",
      urlTitle: "Public High School Graduates",
      description: "",
      title: "Public high school graduates, 1980-81 through 2028-29 (Projection)",
      scope: "usa",
      dataStats: {
        min: 2695,
        max: 444030,
        colorMin: "#CFEC9D",
        colorMax: "#324F00",
        toolTipText: "Number of graduates: "
      },
      citationSource: "https://nces.ed.gov/programs/digest/d18/tables/dt18_219.20.asp?current=yes",
      dataSource:
        "https://gist.githubusercontent.com/dhth/a8d70e6efc2bd65df8d82a264a9d66c5/raw/3fc8d03598ba1d3125bf1b81b353bf8036206202/9-public-school-graduates.json",
      tags: ["education", "time-series"]
    },
    {
      type: "radio-based-chloropleth-with-radio-controls",
      url: "/us-public-high-school-graduates-by-sex-ethnicity-2012",
      urlTitle: "Public high school graduates, by sex and ethnicity (2012-13)",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/470ddaa100071553a2ffbe1dcc63649c/raw/798e7c04e96a3f8945800830b9ed94703cdc3e52/10-public-high-school-graduates-by-sex-ethnicity-2012.json",
      title: "Public high school graduates, by sex and ethnicity (2012-13)",
      scope: "usa",
      dataStats: {
        both: {
          "all": { min: 3961.0, max: 422125.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Both Sexes All Ethnicities: " },
          "white": { min: 142.0, max: 125492.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Both Sexes White: " },
          "black": { min: 62.0, max: 38772.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Both Sexes Black: " },
          "hispanic": { min: 83.0, max: 198993.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Both Sexes Hispanic: " },
          "asian/pacific_islander": { min: 59.0, max: 57667.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Both Sexes Asian/Pacific Islander: " },
          "american_indian": { min: 7.0, max: 6441.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Both Sexes American Indian: " },
          "two_or_more_races": { min: 31.0, max: 9906.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Both Sexes Two Or More Races: " }},
        male: {
          "all": { min: 1732.0, max: 208126.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Male All Ethnicites: " },
          "white": { min: 64.0, max: 62954.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Male White: " },
          "black": { min: 34.0, max: 19177.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Male Black: " },
          "hispanic": { min: 43.0, max: 96324.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Male Hispanic: " },
          "asian/pacific_islander": { min: 26.0, max: 29437.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Male Asian/Pacific Islander: " },
          "american_indian": { min: 3.0, max: 3205.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Male American Indian: " },
          "two_or_more_races": { min: 12.0, max: 4868.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Male Two Or More Races: " }},
        female: {
          "all": { min: 2228.0, max: 213999.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Female All Ethnicities: " },
          "white": { min: 78.0, max: 62538.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Female White: " },
          "black": { min: 28.0, max: 19595.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Female Black: " },
          "hispanic": { min: 40.0, max: 102669.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Female Hispanic: " },
          "asian/pacific_islander": { min: 34.0, max: 28230.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Female Asian/Pacific Islander: " },
          "american_indian": { min: 4.0, max: 3236.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Female American Indian: " },
          "two_or_more_races": { min: 19.0, max: 5038.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Female Two Or More Races: " }}
      },
      textAboveMainRadioControls: "Choose Sex:",
      textAboveSecondaryRadioControls: "Choose Ethnicity:",
      citationSources: ["https://nces.ed.gov/programs/digest/d18/tables/dt18_219.32.asp?current=yes"],
      tags: ["education", "high-school"]
    },
    {
      type: "radio-based-chloropleth",
      url: "/us-high-school-dropouts-2017",
      urlTitle: "Percentage of high school dropouts: 2017",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/e4cf015646c744b9bad0e9a2af98fd01/raw/5b41e9df5791a2395a226ad164c4b47973efac8c/11-high-school-dropouts.json",
      title: "Percentage of high school dropouts among persons 16 to 24 years old: 2017",
      scope: "usa",
      dataStats: {
        "total": { min: 2.9, max: 8.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total: ", toolTipTextAfter: "&percnt;" },
        "white": { min: 1.6, max: 7.6, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "White: ", toolTipTextAfter: "&percnt;" },
        "black": { min: 3.3, max: 20.4, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Black: ", toolTipTextAfter: "&percnt;" },
        "hispanic": { min: 4.2, max: 17.2, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Hispanic: ", toolTipTextAfter: "&percnt;" },
        "asian": { min: 0.4, max: 7.4, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Asian: ", toolTipTextAfter: "&percnt;" },
        "pacific_islander": { min: 6.5, max: 6.5, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Pacific Islander: ", toolTipTextAfter: "&percnt;" },
        "american_indian/alaska_native": { min: 5.3, max: 23.9, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "American Indian/Alaska Native: ", toolTipTextAfter: "&percnt;" },
        "two_or_more_races": { min: 2.2, max: 19.3, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Two Or More Races: ", toolTipTextAfter: "&percnt;" }
      },
      textAboveMapControls: "Select a race/ethnicity:",
      citationSource: "https://nces.ed.gov/programs/digest/d18/tables/dt18_219.85a.asp?current=yes",
      tags: ["education","high-school", "dropouts"]
    },
    {
      type: "radio-based-chloropleth-with-radio-controls",
      url: "/us-average-act-scores-2014-and-2018",
      urlTitle: "Average ACT scores (2014 and 2018)",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/a1cfb45984eac845e5df91aa734167f3/raw/847fca73ab5c5de2bac70c3e22f0c0fb7ec22fc6/12-average-act-scores.json",
      title: "Average ACT scores and percentage of graduates taking the ACT (2014 and 2018)",
      scope: "usa",
      dataStats: {
        "2014": {
          "composite_score": { min: 18.2, max: 24.3, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Composite Score: " },
          "english_score": { min: 16.9, max: 24.2, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "English Score: " },
          "mathematics_score": { min: 18.3, max: 24.6, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Mathematics Score: " },
          "reading_score": { min: 18.3, max: 24.5, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Reading Score: " },
          "science_score": { min: 18.1, max: 23.6, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Science Score: " },
          "percent_taking_act": { min: 9.0, max: 100.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Percent Taking Act: ", toolTipTextAfter: "&percnt;" }
        },
        "2018": {
          "composite_score": { min: 17.7, max: 25.6, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Composite Score: " },
          "english_score": { min: 16.6, max: 26.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "English Score: " },
          "mathematics_score": { min: 17.8, max: 25.2, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Mathematics Score: " },
          "reading_score": { min: 18.0, max: 26.1, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Reading Score: " },
          "science_score": { min: 17.9, max: 24.9, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Science Score: " },
          "percent_taking_act": { min: 7.0, max: 100.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Percent Taking Act: ", toolTipTextAfter: "&percnt;" }
        }
      },
      textAboveMainRadioControls: "Choose Year:",
      textAboveSecondaryRadioControls: "Choose Parameter:",
      citationSources: ["https://nces.ed.gov/programs/digest/d18/tables/dt18_226.60.asp?current=yes"],
      tags: ["education","exam-scores"]
    },
    {
      type: "radio-based-chloropleth-with-time-series-data",
      url: "/us-percent-of-public-school-students-carrying-a-weapon",
      urlTitle: "Percentage of public school students who reported carrying a weapon (2005 - 2017)",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/168ca004da6cdd7d28f28545ef47f077/raw/75ebed014d6611ad7ee576903f01dc3e2a539618/13-students-carrying-weapon.json",
      title: "Percentage of public school students in grades 9-12 who reported carrying a weapon at least 1 day during the previous 30 days (2005 - 2017)",
      scope: "usa",
      dataStats: {
        "anywhere": { min: 7.1, max: 29.6, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Percent: ", toolTipTextAfter: "&percnt;" },
        "on_school_property": { min: 2.0, max: 11.5, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Percent: ", toolTipTextAfter: "&percnt;" }
      },
      textAboveMapControls: "Choose location:",
      citationSources: ["https://nces.ed.gov/programs/digest/d18/tables/dt18_231.60.asp?current=yes"],
      tags: ["school"]
    },
    {
      type: "world-radio-based-chloropleth",
      url: "/us-persons-obtaining-lawful-permanent-resident-status-by-broad-class-of-admission-2017",
      urlTitle: "Persons Obtaining Lawful Permanent Resident Status, by Broad Class of Admission: 2017",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/58600e03ac439da36010e41fbbda28f5/raw/873900452b98545169510ce3e38276f9d7f0fba3/14-persons-obtaining-lawful-permanent-resident-status-by-broad-class-of-admission-and-region-and-country-of-birth-2017.json",
      title: "Persons Obtaining Lawful Permanent Resident Status, by Broad Class of Admission: 2017",
      scope: "usa",
      dataStats: {
        "total": { min: 18.0, max: 170581.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total: " },
        "immediate_relatives_of_us_citizens": { min: 6.0, max: 114431.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Immediate Relatives Of US Citizens: " },
        "family_sponsored_preferences": { min: 3.0, max: 34413.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Family Sponsored Preferences: " },
        "employment_based_preferences": { min: 3.0, max: 23569.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Employment Based Preferences: " },
        "diversity": { min: 3.0, max: 3205.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Diversity: " },
        "refugees_and_asylees": { min: 3.0, max: 55117.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Refugees And Asylees: " },
        "other": { min: 1.0, max: 16870.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Other: " }
      },
      radioKeysPreset: {
        "total": "Total",
        "immediate_relatives_of_us_citizens": "Immediate Relatives Of US Citizens",
        "family_sponsored_preferences": "Family Sponsored Preferences",
        "employment_based_preferences": "Employment Based Preferences",
        "diversity": "Diversity",
        "refugees_and_asylees": "Refugees And Asylees",
        "other": "Other"
      },
      textAboveMapControls: "Select a class of admission:",
      citationSource: "https://www.dhs.gov/immigration-statistics/yearbook/2017/table10",
      tags: ["immigration", "permanent-residence"]
    },
    {
      type: "time-series-chloropleth",
      url: "/persons-obtaining-lawful-permanent-resident-status-by-region-and-selected-country-of-last-residence-1820-2009",
      urlTitle: "Persons Obtaining Lawful Permanent Resident Status, by Country of Last Residence (1820 - 2009)",
      mapsDataKey: "USPopulation",
      description: "",
      title: "Persons Obtaining Lawful Permanent Resident Status, by Country of Last Residence (1820 - 2009)",
      scope: "world",
      yearRanges:{
        range: 9,
      },
      dataStats: {
        min: 1,
        max: 1500000,
        colorMin: "#CFEC9D",
        colorMax: "#324F00",
        toolTipText: "Number: "
      },
      citationSource: "https://www.dhs.gov/immigration-statistics/lawful-permanent-residents",
      dataSource:
        "https://gist.githubusercontent.com/dhth/8bd586f6b7bee16ba3632cf2798f3dc5/raw/702c9548d69e0f0964726cda6cc596488b3facb9/15-persons-obtaining-lawful-permanent-resident-status-by-region-and-selected-country-of-last-residence-1820-2009.json",
      tags: ["immigration", "time-series", "permanent-residence"]
    },
    {
      type: "time-series-chloropleth",
      url: "/persons-obtaining-lawful-permanent-resident-status-by-region-and-selected-country-of-last-residence-2010-2017",
      urlTitle: "Persons Obtaining Lawful Permanent Resident Status, by Country of Last Residence (2010 - 2017)",
      mapsDataKey: "USPopulation",
      description: "",
      title: "Persons Obtaining Lawful Permanent Resident Status, by Country of Last Residence (2010 - 2017)",
      scope: "world",
      dataStats: {
        min: 111,
        max: 100000,
        colorMin: "#CFEC9D",
        colorMax: "#324F00",
        toolTipText: "Number: "
      },
      citationSource: "https://www.dhs.gov/immigration-statistics/lawful-permanent-residents",
      dataSource:
        "https://gist.githubusercontent.com/dhth/8ddae6ef9ddc4e9d76044ba8afa8af92/raw/8d4a5ad2366eeb6b0d687234f72a0d366e8e3a3d/16-persons-obtaining-lawful-permanent-resident-status-by-region-and-selected-country-of-last-residence-2010-2017.json",
      tags: ["immigration", "permanent-residence"]
    },
    {
      type: "time-series-chloropleth",
      url: "/persons-obtaining-lawful-permanent-resident-status-by-state-2008-2017",
      urlTitle: "Persons Obtaining Lawful Permanent Resident Status, by state (2008 - 2017)",
      description: "",
      title: "Persons Obtaining Lawful Permanent Resident Status, by state (2008 - 2017)",
      scope: "usa",
      dataStats: {
        min: 414,
        max: 238444,
        colorMin: "#CFEC9D",
        colorMax: "#324F00",
        toolTipText: "Number: "
      },
      citationSource: "https://www.dhs.gov/immigration-statistics/lawful-permanent-residents",
      dataSource:
        "https://gist.githubusercontent.com/dhth/da2e3ee8e0abf1bb3702e738f32f0400/raw/2d4c7fd705b55ea6ec397b948000908f3aecea16/17-persons-obtaining-lawful-permanent-resident-status-by-state-2008-2017.json",
      tags: ["immigration", "permanent-residence"]
    },
    {
      type: "world-radio-based-chloropleth",
      url: "/nonimmigrant-admissions-by-selected-category-of-admission-country-of-citizenship-2017",
      urlTitle: "Nonimmigrant Admissions by Selected Category of Admission and Country of Citizenship: 2017",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/f7239c8e4ff63e0907ded0e02a1a01e0/raw/2cba09983ea216a1cc0d58833c7e9f10ce40f1cf/18-nonimmigrant-admissions-by-selected-category-of-admission-country-of-citizenship-2017.json",
      title: "Non-Immigrant Admissions by Selected Category of Admission and Country of Citizenship: 2017",
      scope: "world",
      dataStats: {
        "total": { min: 245.0, max: 19326562.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total: " },
        "visa_waiver_tourists_and_business_travellers": { min: 100.0, max: 4558681.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Tourists And Business Travellers - Visa Waiver: " },
        "other_waiver_tourists_and_business_travellers": { min: 92.0, max: 18101904.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Tourists And Business Travellers - Others: " },
        "students_and_exchange_visitors": { min: 12.0, max: 616981.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Students And Exchange Visitors: " },
        "temporary_workers_and_families": { min: 6.0, max: 1063537.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Temporary Workers And Families: " },
        "diplomats_and_other_representatives": { min: 49.0, max: 39239.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Diplomats And Other Representatives: " },
        "all_other_classes": { min: 4.0, max: 120905.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "All Other Classes: " },
        "unknown": { min: 1.0, max: 12364.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Unknown: " }
      },
      radioKeysPreset: {
        "total": "Total",
        "visa_waiver_tourists_and_business_travellers": "Tourists And Business Travellers - Visa Waiver",
        "other_waiver_tourists_and_business_travellers": "Tourists And Business Travellers - Other",
        "students_and_exchange_visitors": "Students And Exchange Visitors",
        "temporary_workers_and_families": "Temporary Workers And Families",
        "diplomats_and_other_representatives": "Diplomats And Other Representatives",
        "all_other_classes": "All Other Classes",
        "unknown": "Unknown",
      },
      textAboveMapControls: "Select a category of admission:",
      citationSource: "https://www.dhs.gov/immigration-statistics/yearbook/2017/table28s",
      tags: ["immigration", "non-immigration-admissions"]
    },
    {
      type: "world-radio-based-chloropleth",
      url: "/nonimmigrant-temporary-worker-admissions-by-selected-category-of-admission-country-of-citizenship-2017",
      urlTitle: "Nonimmigrant Temporary Worker Admissions by Selected Category of Admission and Country of Citizenship: 2017",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/10d0f8dedaebd1d7a2850d2dacf681c1/raw/09fb0da1e239f3d8e282004c0e15943e92e3f0d7/19-nonimmigrant-temporary-worker-admissions-by-region-and-country-of-citizenship-2017.json",
      title: "Non-Immigrant Temporary Worker Admissions by Selected Category of Admission and Country of Citizenship: 2017",
      scope: "world",
      dataStats: {
        "total_temporary_workers_and_families": { min: 3.0, max: 1063537.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total Temporary Workers And Families: " },
        "workers_in_specialty_occupations": { min: 3.0, max: 276178.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Workers In Specialty Occupations (H1B): " },
        "seasonal_agricultural_workers": { min: 3.0, max: 393849.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Seasonal Agricultural Workers (H2A): " },
        "seasonal_non_agricultural_workers": { min: 3.0, max: 98871.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Seasonal Non Agricultural Workers (H2B, H2R): " },
        "workers_with_extra_ordinary_ability_achievement": { min: 3.0, max: 29651.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Workers With Extra Ordinary Ability Achievement (O1, O2): " },
        "athletes__artists__and_entertainers": { min: 3.0, max: 38105.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Athletes  Artists  And Entertainers (P1 to P3): " },
        "intra_company_transferees": { min: 3.0, max: 191321.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Intra Company Transferees (L1): " },
        "treaty_traders_and_investors": { min: 3.0, max: 110946.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Treaty Traders And Investors (E1 to E3): " },
        "other": { min: 3.0, max: 674479.0, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Other: " }
      },
      radioKeysPreset: {
        "total_temporary_workers_and_families": "Total Temporary Workers And Families",
        "workers_in_specialty_occupations": "Workers In Specialty Occupations (H1B)",
        "seasonal_agricultural_workers": "Seasonal Agricultural Workers (H2A)",
        "seasonal_non_agricultural_workers": "Seasonal Non Agricultural Workers (H2B, H2R)",
        "workers_with_extra_ordinary_ability_achievement": "Workers With Extra Ordinary Ability Achievement (O1, O2)",
        "athletes__artists__and_entertainers": "Athletes  Artists  And Entertainers (P1 to P3)",
        "intra_company_transferees": "Intra Company Transferees (L1)",
        "treaty_traders_and_investors": "Treaty Traders And Investors (E1 to E3)",
        "other": "Other",
      },
      textAboveMapControls: "Select a category of admission:",
      citationSource: "https://www.dhs.gov/immigration-statistics/yearbook/2017/table32",
      tags: ["immigration", "non-immigration-worker-admissions"]
    },
    {
      type: "time-series-chloropleth",
      url: "/persons-naturalized-by-country-of-birth-1991-2018",
      urlTitle: "Persons Naturalized by Country of Birth (1991-2018)",
      description: "",
      title: "Persons Naturalized by Country of Birth (1991-2018)",
      scope: "world",
      dataStats: {
        min: 3,
        max: 100000,
        colorMin: "#CFEC9D",
        colorMax: "#324F00",
        toolTipText: "Number: "
      },
      citationSource: "https://www.dhs.gov/immigration-statistics/naturalizations",
      dataSource:
        "https://gist.githubusercontent.com/dhth/073f2b7746b3feca3a271f23773ea989/raw/3a78d7542aa488af8fd491abae7ea5faeac23b25/20-persons-naturalized-by-country-of-birth.json",
      tags: ["immigration", "naturalization"]
    },
    {
      type: "radio-based-chloropleth",
      url: "/annual-estimates-of-the-resident-population-by-race-and-state-2018",
      urlTitle: "Annual Estimates of the Resident Population by Race and State: 2018",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/360047fc573e1480fd666f1de8bdca17/raw/aa9d614015a951c79482b9a2b43114a94e3426e3/21-annual-estimates-of-the-resident-population-by-race-and-state-2018.json",
      title: "Annual Estimates of the Resident Population by Race and State: 2018",
      scope: "usa",
      dataStats: {
        white: { min: 320374, max: 28531740, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "White: " },
        black_or_african_american: { min: 6237, max: 3673855, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Black or African American: " },
        american_indian_and_alaska_native: { min: 2457, max: 651076, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "American Indian And Alaska Native: " },
        asian: { min: 6213, max: 6063600, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Asian: " },
        native_hawaiian_and_other_pacific_islander: { min: 247, max: 199872, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Native Hawaiian And Other Pacific Islander: " },
        two_or_more_races: { min: 1259, max: 1554757, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Two Or More Races: " }
      },
      radioKeysPreset: {
        "white": "White",
        "black_or_african_american": "Black or African American",
        "american_indian_and_alaska_native": "American Indian and Alaska Native",
        "asian": "Asian",
        "native_hawaiian_and_other_pacific_islander": "Native Hawaiian and other Pacific Islander",
        "two_or_more_races": "Two or More Races",
      },
      textAboveMapControls: "Select a race:",
      citationSource: "https://www.census.gov/data/tables/time-series/demo/popest/2010s-state-detail.html",
      tags: ["census", "population"]
    },
    {
      type: "radio-based-custom-chloropleth",
      url: "/annual-estimates-of-the-resident-population-by-race-california-2018",
      urlTitle: "Annual Estimates of the Resident Population by Race, California: 2018",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/9c4734d9ecc5749cceae41968b73cdb0/raw/4f4f4d33a82e7955ee9cf1645c5538c93bf555f2/22-annual-estimate-of-resident-population-by-race-california-2018.json",
      customTopoJsonSource: customMapsMappings["california"],
      title: "Annual Estimates of the Resident Population by Race, California: 2018",
      dataStats: {
        all: { min: 1175, max: 9818605, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "All: " },
        white: { min: 896, max: 7056710, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "White: " },
        black_or_african_american: { min: 0, max: 920648, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Black or African American: " },
        american_indian_and_alaska_native: { min: 51, max: 146005, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "American Indian and Alaska Native: " },
        asian: { min: 7, max: 1393578, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Asian: " },
        native_hawaiian_and_other_pacific_islander: { min: 0, max: 36443, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Native Hawaiian and other Pacific Islander: " },
        two_or_more_races: { min: 29, max: 265221, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Two or more Races: " },
      },
      scalingFactor:3,
      radioKeysPreset: {
        "all": "All",
        "white": "White",
        "black_or_african_american": "Black or African American",
        "american_indian_and_alaska_native": "American Indian and Alaska Native",
        "asian": "Asian",
        "native_hawaiian_and_other_pacific_islander": "Native Hawaiian and other Pacific Islander",
        "two_or_more_races": "Two or more Races"
      },
      topoJsonScope: "cb_2015_california_county_20m",
      scaleValue:2500,
      scaleMultiplier: scaleMultiplierMappings["california"],
      projectionCoordinates: projectionMappings["california"],
      textAboveMapControls: "Select a race:",
      citationSource: "https://www.census.gov/data/tables/time-series/demo/popest/2010s-counties-detail.html",
      tags: ["census", "population", "state-counties", "california"]
    },
    {
      type: "radio-based-custom-chloropleth",
      url: "/estimates-of-components-of-resident-population-change-california-2010-2018",
      urlTitle: "Estimates of Components of Resident Population Change, California (2010 - 2018)",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/04be4d3de83bc80a3c13868f5b409764/raw/25b4ca90bc2286964241cd790a9f62c0b276bf05/23-estimates-of-components-of-resident-population-change-california-2010-2018.json",
      customTopoJsonSource: customMapsMappings["california"],
      title: "Estimates of Components of Resident Population Change, California (2010 - 2018)",
      dataStats: {
        total_population_change: { min: -4093, max: 286846, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Total Population Change: ", divergingColors:true },
        natural_increase: { min: -1451, max: 539224, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Natural Increase: ", divergingColors: true  },
        births: { min: 48, max: 1045817, colorMin: "#ffcccc", colorMax: "#ff3232", toolTipText: "Births: " },
        deaths: { min: 57, max: 506593, colorMin: "#cce5cc", colorMax: "#198c19", toolTipText: "Deaths: " },
        total_migration: { min: -250269, max: 140099, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Total Migration: ", divergingColors: true },
        international_migration: { min: -157, max: 305423, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "International Migration: ", divergingColors: true },
        domestic_migration: { min: -555692, max: 121574, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Domestic Migration: ", divergingColors: true },
      },
      scalingFactor: 3,
      radioKeysPreset: {
        "total_population_change": "Total Population Change",
        "natural_increase": "Natural Increase",
        "births": "Births",
        "deaths": "Deaths",
        "total_migration": "Total Migration",
        "international_migration": "International Migration",
        "domestic_migration": "Domestic Migration",
      },
      topoJsonScope: "cb_2015_california_county_20m",
      scaleValue: 2500,
      scaleMultiplier: scaleMultiplierMappings["california"],
      projectionCoordinates: projectionMappings["california"],
      textAboveMapControls: "Select a category:",
      citationSource: "https://www.census.gov/data/datasets/time-series/demo/popest/2010s-counties-total.html",
      tags: ["census", "population", "state-counties", "california"]
    },
    {
      type: "radio-based-custom-chloropleth",
      url: "/annual-estimates-of-the-resident-population-by-race-texas-2018",
      urlTitle: "Annual Estimates of the Resident Population by Race, Texas: 2018",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/48dbf11b3335265df2535991e1d95378/raw/18bedd9907865b4001f8b3cfaaa34fbe638cde27/25-annual-estimate-of-resident-population-by-race-texas.csv",
      customTopoJsonSource: customMapsMappings["texas"],
      title: "Annual Estimates of the Resident Population by Race, Texas: 2018",
      dataStats: {
        all: { min: 82, max: 4092459, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "All: " },
        white: { min: 78, max: 2918354, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "White: " },
        black_or_african_american: { min: 0, max: 798077, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Black Or African American: " },
        american_indian_and_alaska_native: { min: 0, max: 46842, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "American Indian And Alaska Native: " },
        asian: { min: 0, max: 261637, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Asian: " },
        native_hawaiian_and_other_pacific_islander: { min: 0, max: 5498, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Native Hawaiian And Other Pacific Islander: " },
        two_or_more_races: { min: 0, max: 62051, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Two Or More Races: " },
      },
      scalingFactor: 2,
      radioKeysPreset: {
        "all": "All",
        "white": "White",
        "black_or_african_american": "Black Or African American",
        "american_indian_and_alaska_native": "American Indian And Alaska Native",
        "asian": "Asian",
        "native_hawaiian_and_other_pacific_islander": "Native Hawaiian And Other Pacific Islander",
        "two_or_more_races": "Two Or More Races",
      },
      topoJsonScope: "cb_2015_texas_county_20m",
      scaleValue: 2500,
      scaleMultiplier: scaleMultiplierMappings["texas"],
      projectionCoordinates: projectionMappings["texas"],
      textAboveMapControls: "Select a race:",
      citationSource: "https://www.census.gov/data/tables/time-series/demo/popest/2010s-counties-detail.html",
      tags: ["census", "population", "state-counties", "texas"]
    },
    {
      type: "radio-based-custom-chloropleth",
      url: "/estimates-of-components-of-resident-population-change-texas-2010-2018",
      urlTitle: "Estimates of Components of Resident Population Change, Texas (2010 - 2018)",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/5172831b9d0d46490a0a7bdbf4f4e904/raw/e594a2f739afae3a3e3f5bbd72c6cf0ac0c96e72/24-estimates-of-components-of-resident-population-change-texas-2010-2018.json",
      customTopoJsonSource: customMapsMappings["texas"],
      title: "Estimates of Components of Resident Population Change, Texas (2010 - 2018)",
      dataStats: {
        total_population_change: { min: -2376, max: 605431, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Total Population Change: ", divergingColors: true },
        natural_increase: { min: -1676, max: 370217, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Natural Increase: ", divergingColors: true },
        births: { min: 17, max: 573962, colorMin: "#ffcccc", colorMax: "#ff3232", toolTipText: "Births: ", divergingColors: true },
        deaths: { min: 10, max: 203745, colorMin: "#cce5cc", colorMax: "#198c19", toolTipText: "Deaths: " },
        total_migration: { min: -28701, max: 235934, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Total Migration: ", divergingColors: true },
        international_migration: { min: -117, max: 259047, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "International Migration: ", divergingColors: true },
        domestic_migration: { min: -50317, max: 125277, colorMin: "#198c19", colorMax: "#ff3232", toolTipText: "Domestic Migration: ", divergingColors: true },
      },
      scalingFactor: 2,
      radioKeysPreset: {
        "total_population_change": "Total Population Change",
        "natural_increase": "Natural Increase",
        "births": "Births",
        "deaths": "Deaths",
        "total_migration": "Total Migration",
        "international_migration": "International Migration",
        "domestic_migration": "Domestic Migration",
      },
      topoJsonScope: "cb_2015_texas_county_20m",
      scaleValue: 2500,
      scaleMultiplier: scaleMultiplierMappings["texas"],
      projectionCoordinates: projectionMappings["texas"],
      textAboveMapControls: "Select a category:",
      citationSource: "https://www.census.gov/data/datasets/time-series/demo/popest/2010s-counties-total.html",
      tags: ["census", "population", "state-counties", "texas"]
    },
    {
      type: "radio-based-custom-chloropleth",
      url: "/occupations-by-place-of-residence-europe-2011",
      urlTitle: "Occupations, by Place of Residence, Europe: 2011",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/465c0bf758a59484eaeb4173c0ac0739/raw/cb438d8c222a3ed49632b453aa83c5c9762f9793/26-occupations-of-persons-in-europe-by-place-of-residence-2011.csv",
      customTopoJsonSource: "https://raw.githubusercontent.com/leakyMirror/map-of-europe/master/TopoJSON/europe.topojson",
      title: "Occupations, by Place of Residence, Europe: 2011",
      dataStats: {
        total: { min: 36149, max: 79652380, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Total: " },
        managers: { min: 0, max: 3358230, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Managers: " },
        professionals: { min: 0, max: 7135060, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Professionals: " },
        technicians_and_associate_professionals: { min: 0, max: 7862620, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Technicians and Associate Professionals: " },
        clerical_support_workers: { min: 0, max: 5660850, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Clerical Support Workers: " },
        service_and_sales_workers: { min: 0, max: 6611630, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Service and Sales Workers: " },
        skilled_agricultural_forestry_and_fishery_workers: { min: 0, max: 2043909, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Skilled Agricultural, Forestry and Fishery Workers: " },
        craft_and_related_trades_workers: { min: 0, max: 5394080, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Craft and Related Trades Workers: " },
        plant_and_machine_operators_and_assemblers: { min: 0, max: 2777290, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Plant and Machine Operators And Assemblers: " },
        elementary_occupations: { min: 0, max: 4319337, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Elementary Occupations: " },
        armed_forces_occupations: { min: 0, max: 340564, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Armed Forces Occupations: " },
        not_stated: { min: 0, max: 4814164, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Not Stated: " },
        not_applicable: { min: 16489, max: 37693920, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Not Applicable: " },
      },
      scalingFactor: 1,
      radioKeysPreset: {
        "total": "Total",
        "managers": "Managers",
        "professionals": "Professionals",
        "technicians_and_associate_professionals": "Technicians and Associate Professionals",
        "clerical_support_workers": "Clerical Support Workers",
        "service_and_sales_workers": "Service And Sales Workers",
        "skilled_agricultural_forestry_and_fishery_workers": "Skilled Agricultural, Forestry, and Fishery Workers",
        "craft_and_related_trades_workers": "Craft and Related Trades Workers",
        "plant_and_machine_operators_and_assemblers": "Plant and Machine Operators, and Assemblers",
        "elementary_occupations": "Elementary Occupations",
        "armed_forces_occupations": "Armed Forces Occupations",
        "not_stated": "Not Stated",
        "not_applicable": "Not Applicable",
      },
      topoJsonScope: "europe",
      scaleValue: 460,
      scaleMultiplier: scaleMultiplierMappings["europe"],
      projectionCoordinates: [13, 56],
      textAboveMapControls: "Select an occupation:",
      citationSource: "https://ec.europa.eu/CensusHub2/query.do?step=selectHyperCube&qhc=false",
      tags: ["census", "europe"]
    },
    {
      type: "radio-based-custom-chloropleth",
      url: "/industry-of-work-by-place-of-residence-europe-2011",
      urlTitle: "Industry of Work, by Place of Residence, Europe: 2011",
      description: "",
      dataSource:
        "https://gist.githubusercontent.com/dhth/41f3b82cbbfa925861c2506c761cb38c/raw/d4ac32131d37d911da4fac491f5ac92eba627ecb/27-industry-of-work-by-place-of-residence-europe-2011.json",
      customTopoJsonSource: "https://raw.githubusercontent.com/leakyMirror/map-of-europe/master/TopoJSON/europe.topojson",
      title: "Industry of Work, by Place of Residence, Europe: 2011",
      dataStats: {
        agriculture_forestry_and_fishing: { min: 218, max: 2450075, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Agriculture, Forestry, and Fishing: " },
        mining_and_quarrying: { min: 32, max: 294040, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Mining and Quarrying: " },
        manufacturing: { min: 4083, max: 8879490, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Manufacturing: " },
        electricity_gas_steam_and_air_conditioning_supply: { min: 152, max: 439780, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Electricity, Gas Steam and Air Conditioning Supply: " },
        water_supply__sewerage_waste_management_and_remediation_activities: { min: 65, max: 280900, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Water Supply, Sewerage Waste Management, and Remediation Activities: " },
        construction: { min: 1591, max: 2529200, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Construction: " },
        wholesale_and_retail_trade__repair_of_motor_vehicles_and_motorcycles: { min: 1593, max: 5172855, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Wholesale and Retail Trade, Repair of Motor Vehicles and Motorcycles: " },
        transportation_and_storage: { min: 510, max: 1930610, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Transportation and Storage: " },
        accommodation_and_food_service_activities: { min: 595, max: 1989702, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Accommodation and Food Service Activities: " },
        information_and_communication: { min: 398, max: 2088890, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Information and Communication: " },
        financial_and_insurance_activities: { min: 1579, max: 1429180, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Financial and Insurance Activities: " },
        real_estate_activities: { min: 63, max: 444170, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Real Estate Activities: " },
        professional_scientific_and_technical_activities: { min: 2358, max: 2000115, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Professional, Scientific and Technical Activities: " },
        administrative_and_support_service_activities: { min: 571, max: 1594610, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Administrative and Support Service Activities: " },
        public_administration_and_defence__compulsory_social_security: { min: 1454, max: 2862970, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Public Administration and Defence, Compulsory Social Security: " },
        education: { min: 878, max: 3024440, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Education: " },
        human_health_and_social_work_activities: { min: 1349, max: 4769360, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Human Health and Social Work Activities: " },
        arts_entertainment_and_recreation: { min: 226, max: 765965, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Arts, Entertainment and Recreation: " },
        other_service_activities: { min: 458, max: 2248080, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Other Service Activities: " },
        activities_of_households_as_employers__undifferentiated_goods__and_services_producing_activities_of_households_for_own_use: { min: 0, max: 613870, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Activities of Households as Employers, Undifferentiated Goods and Services Producing Activities of Households for own use: " },
        activities_of_extraterritorial_organisations_and_bodies: { min: 0, max: 31720, colorMin: "#CCF2CC", colorMax: "#006599", toolTipText: "Activities of Extraterritorial Organisations and Bodies: " },
      },
      scalingFactor: 1,
      radioKeysPreset: {
        "agriculture_forestry_and_fishing": "Agriculture, Forestry and Fishing",
        "mining_and_quarrying": "Mining and Quarrying",
        "manufacturing": "Manufacturing",
        "electricity_gas_steam_and_air_conditioning_supply": "Electricity, Gas, Steam and Air Conditioning Supply",
        "water_supply__sewerage_waste_management_and_remediation_activities": "Water Supply, Sewerage Waste Management, and Remediation Activities",
        "construction": "Construction",
        "wholesale_and_retail_trade__repair_of_motor_vehicles_and_motorcycles": "Wholesale and Retail Trade, Repair Of Motor Vehicles and Motorcycles",
        "transportation_and_storage": "Transportation and Storage",
        "accommodation_and_food_service_activities": "Accommodation and Food Service Activities",
        "information_and_communication": "Information and Communication",
        "financial_and_insurance_activities": "Financial and Insurance Activities",
        "real_estate_activities": "Real Estate Activities",
        "professional_scientific_and_technical_activities": "Professional, Scientific, and Technical Activities",
        "administrative_and_support_service_activities": "Administrative and Support Service Activities",
        "public_administration_and_defence__compulsory_social_security": "Public Administration, and Defence, Compulsory Social Security",
        "education": "Education",
        "human_health_and_social_work_activities": "Human Health And Social Work Activities",
        "arts_entertainment_and_recreation": "Arts, Entertainment and Recreation",
        "other_service_activities": "Other Service Activities",
        "activities_of_households_as_employers__undifferentiated_goods__and_services_producing_activities_of_households_for_own_use": "Activities of Households as Employers, Undifferentiated Goods Aad Services Producing Activities of Households for own use",
        "activities_of_extraterritorial_organisations_and_bodies": "Activities of Extraterritorial Organisations and Bodies",
      },
      extendControlsVertically: false,
      topoJsonScope: "europe",
      scaleValue: 500,
      scaleMultiplier: scaleMultiplierMappings["europe"],
      projectionCoordinates: [13, 56],
      textAboveMapControls: "Select an industry:",
      citationSource: "https://ec.europa.eu/CensusHub2/query.do?step=selectHyperCube&qhc=false",
      tags: ["census", "europe"]
    },
  ]
};



let tagsAll = [];
maps["US"].map(el=>{
  el["tags"].map(t => {
    tagsAll.push(t);
  });
});

const tags = Array.from(new Set(tagsAll));
const tagToColor = {
  "census": "#336699",
  "population": "#8485ce",
  "time-series": "#658cb3",
  "income": "#313b72",
  "education": "#8956e1",
  "exam-scores": "#586069",
  "high-school" : "#e10044",
  "college" : "#5a1d57",
  "salaries" : "#397e56",
  "dropouts" : "#00b3e6",
  "school" : "#57334f",
  "immigration" : "#19b800",
  "permanent-residence" : "#4a4dff",
  "non-immigration-admissions" : "#0003a1",
  "non-immigration-worker-admissions" : "#6665d2",
  "naturalization" : "#6d84ab",
  "state-counties": "#228832",
  "california": "#3ec099",
  "texas": "#3c41d5",
  "europe": "#003399"
}
// for (let i=0; i<tags.length; i++){
//   console.log(`"${tags[i]}" : "",`)
// }
export {maps, tags, tagToColor};
